import { useAuth } from "./useAuth";

export interface SubscriptionGate {
  canAddIntegration: boolean;
  canInviteTeamMember: boolean;
  canModifyApps: boolean;
  canTriggerDataSync: boolean;
  isCancelled: boolean;
  isActive: boolean;
}

export const useSubscriptionGate = (): SubscriptionGate => {
  const { user, isVip } = useAuth();

  const isCancelled =
    user?.subscription_status === "canceled" && !!user?.plan;

  const isActive =
    isVip ||
    user?.subscription_status === "active" ||
    user?.subscription_status === "trialing" || user?.parent?.subscription_status === "active" ||
    user?.parent?.subscription_status === "trialing";

  return {
    canAddIntegration: isActive,
    canInviteTeamMember: isActive,
    canModifyApps: isActive,
    canTriggerDataSync: isActive,
    isCancelled,
    isActive,
  };
};
